type Redirect = {
  from: string;
  to: string;
  comparison: 'equals' | 'prefix';

  // old angularjs routes that have been moved to a new base path
  // will still need their '#/' location hash (fragment) because
  // angularjs will still use it for it's own routing.
  keepHash?: boolean;
};

const redirects: Redirect[] = [
  {
    from: '/#/login',
    to: '/account/login',
    comparison: 'equals',
  },
  {
    from: '/#/logout',
    to: '/account/logout',
    comparison: 'equals',
  },
  {
    from: '/#/forgotPassword',
    to: '/account/forgot-password',
    comparison: 'equals',
  },
  {
    from: '/#/resetPassword',
    to: '/account/reset-password',
    comparison: 'prefix', // the location hash contains a query string as well for `?code=...`
    keepHash: true,
  },
  {
    from: '/#/setPassword',
    to: '/account/setup-password',
    comparison: 'prefix', // the location hash contains a query string as well for `?code=...`
    keepHash: true,
  },
];

/**
 * TryRedirect will attempt to redirect the page based on a static list
 * of old hash-routes that need to map to new browser-routes.
 *
 * The function returns `true` when the page is redirected so that
 * the caller can exit early to avoid flashes of content.
 */
export function tryRedirect(): boolean {
  const currentRoute = window.location.pathname + window.location.hash;

  const match = redirects.find((redirect) => {
    if (redirect.comparison === 'equals') {
      return currentRoute === redirect.from;
    }

    if (redirect.comparison === 'prefix') {
      return currentRoute.startsWith(redirect.from);
    }

    return false;
  });

  if (match) {
    if (!match.keepHash) {
      window.location.replace(match.to);
    } else {
      window.location.pathname = match.to; // only change the path so that the hash is retained.
    }
    return true;
  }

  return false;
}
